import { db } from './firebase';
import { collection, writeBatch, doc, serverTimestamp } from 'firebase/firestore';

export const seedDatabase = async () => {
  try {
    const batch = writeBatch(db);

    // 1. Seed EFMS Sites
    const efmsSitesRef = collection(db, 'efms_sites');
    const sites = [
      { siteId: 'ABJ-001', siteName: 'Abuja Metro Hub', address: '14 Wuse Way, Abuja', latitude: 9.0765, longitude: 7.3986, region: 'North Central', state: 'FCT', status: 'active' },
      { siteId: 'LAG-002', siteName: 'Lagos Core Node', address: 'Victoria Island, Lagos', latitude: 6.5244, longitude: 3.3792, region: 'South West', state: 'Lagos', status: 'maintenance' },
      { siteId: 'PHC-003', siteName: 'Port Harcourt Ring', address: 'Trans Amadi, PH', latitude: 4.8156, longitude: 7.0498, region: 'South South', state: 'Rivers', status: 'active' },
    ];
    sites.forEach(site => {
      const newDoc = doc(efmsSitesRef);
      batch.set(newDoc, site);
    });

    // 2. Seed Assets
    const assetsRef = collection(db, 'assets');
    const assets = [
      { assetId: 'AST-1001', assetName: 'Fujikura 90S+ Splicing Machine', assetType: 'equipment', quantity: 1, currentHolder: 'Tech Team Alpha', status: 'in_use' },
      { assetId: 'AST-1002', assetName: 'Cisco ASR 9000 Router', assetType: 'equipment', quantity: 2, currentHolder: 'Data Center 1', status: 'available' },
      { assetId: 'AST-1003', assetName: '10km Single Mode Fiber Cable', assetType: 'consumable', quantity: 50, currentHolder: 'Main Store', status: 'available' },
      { assetId: 'AST-1004', assetName: 'Toyota Hilux (Fleet 04)', assetType: 'vehicle', quantity: 1, currentHolder: 'Maintenance Team B', status: 'in_use' },
    ];
    assets.forEach(asset => {
      const newDoc = doc(assetsRef);
      batch.set(newDoc, asset);
    });

    // 3. Seed Tickets
    const ticketsRef = collection(db, 'tickets');
    const tickets = [
      { ticketId: 'INC-9012', title: 'Fiber Cut on Route 4', description: 'Excavation caused a major fiber cut near Wuse zone 5.', siteId: 'ABJ-001', severity: 'critical', status: 'open', createdAt: new Date().toISOString() },
      { ticketId: 'INC-9013', title: 'Power Failure at Core Node', description: 'Backup generator failed to start during grid outage.', siteId: 'LAG-002', severity: 'high', status: 'in_progress', createdAt: new Date().toISOString() },
      { ticketId: 'INC-9014', title: 'Routine Antenna Alignment', description: 'Microwave link alignment required for optimization.', siteId: 'PHC-003', severity: 'low', status: 'resolved', createdAt: new Date().toISOString() },
    ];
    tickets.forEach(ticket => {
      const newDoc = doc(ticketsRef);
      batch.set(newDoc, ticket);
    });

    // 4. Seed Reports
    const reportsRef = collection(db, 'reports');
    const reports = [
      { reportType: 'DAR', fieldStaffId: 'staff-123', siteId: 'ABJ-001', description: 'Daily site inspection completed. Temperature levels normal.', photos: ['https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=400&q=80'], status: 'approved', createdAt: new Date().toISOString() },
      { reportType: 'weekly', fieldStaffId: 'staff-124', siteId: 'LAG-002', description: 'Weekly generator fuel level check and battery voltage tests.', photos: ['https://images.unsplash.com/photo-1519211975560-6a75727e163d?auto=format&fit=crop&w=400&q=80'], status: 'pending', createdAt: new Date().toISOString() },
    ];
    reports.forEach(report => {
      const newDoc = doc(reportsRef);
      batch.set(newDoc, report);
    });

    // 5. Seed Verisure Sites
    const verisureSitesRef = collection(db, 'verisure_sites');
    
    // We create predictable IDs for the Verisure Sites so we can link cabinets to them
    const vSite1Ref = doc(verisureSitesRef, 'v-site-1');
    const vSite2Ref = doc(verisureSitesRef, 'v-site-2');
    
    batch.set(vSite1Ref, { name: 'Alpha Telecom Mast', address: 'Hilltop Avenue, Region 1', createdBy: 'seed', status: 'active', createdAt: serverTimestamp() });
    batch.set(vSite2Ref, { name: 'Beta Relay Station', address: 'Valley Road, Region 2', createdBy: 'seed', status: 'active', createdAt: serverTimestamp() });

    // 6. Seed Verisure Cabinets
    const cabinetsRef = collection(db, 'verisure_cabinets');
    
    // We create predictable IDs for the cabinets to link logs
    const cab1Ref = doc(cabinetsRef, 'cab-101');
    const cab2Ref = doc(cabinetsRef, 'cab-102');

    // Make sure to use the actual local network or deployed URL in production. We'll use localhost for the demo.
    const baseUrl = window.location.origin;
    
    batch.set(cab1Ref, { siteId: 'v-site-1', cabinetLabel: 'Main Core Switch Cabinet', qrCodeUrl: `${baseUrl}/verisure/cabinet/cab-101`, status: 'active', createdAt: serverTimestamp() });
    batch.set(cab2Ref, { siteId: 'v-site-2', cabinetLabel: 'Backup Battery Bank', qrCodeUrl: `${baseUrl}/verisure/cabinet/cab-102`, status: 'active', createdAt: serverTimestamp() });

    // 7. Seed Verisure Logs
    const logsRef = collection(db, 'verisure_logs');
    const logs = [
      { 
        cabinetId: 'cab-101', siteId: 'v-site-1', technicianId: 'tech-001', technicianName: 'John Doe', 
        notes: 'Monthly cleaning and port inspection. All clear.', statusTag: 'Routine', 
        photoUrls: ['https://images.unsplash.com/photo-1498084393753-b411b2d26b34?auto=format&fit=crop&w=400&q=80'], 
        timestamp: serverTimestamp(), geolocation: { latitude: 9.1, longitude: 7.4 }
      },
      { 
        cabinetId: 'cab-102', siteId: 'v-site-2', technicianId: 'tech-002', technicianName: 'Jane Smith', 
        notes: 'Replaced faulty battery cell #4.', statusTag: 'Repair', 
        photoUrls: ['https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=400&q=80'], 
        timestamp: serverTimestamp(), geolocation: { latitude: 9.2, longitude: 7.5 }
      }
    ];
    logs.forEach(log => {
      const newDoc = doc(logsRef);
      batch.set(newDoc, log);
    });

    // Commit the batch
    await batch.commit();
    console.log('Database successfully seeded with mock data!');
    alert('Database successfully seeded! Please refresh the page to see the new data.');

  } catch (error) {
    console.error('Error seeding database: ', error);
    alert('Failed to seed database. See console for details.');
  }
};
